/* eslint-disable no-param-reassign */
/* eslint-disable padding-line-between-statements */
import { ViewModelForm } from "@xengage/gw-portals-viewmodel-react";
import React from "react";
import _ from 'lodash';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { ClausesComponentVM } from 'ent-components-platform-react';
import { useCallback, useEffect } from "react";
import styles from '../TWIABuildingSummaryAccordions.module.scss';
import metadata from './CoverageSummaryAccordion.metadata.json';

function CoverageSummaryAccordion(props) {
    const {   data: building, index, path: buildingPath, isQuotePage, isPolicySummary } = props;
    const isClaimSummary = true;

    const resolvers = {
        resolveCallbackMap: {
        },
        resolveClassNameMap: styles,
        resolveComponentMap: {
            clausesComponentVM: ClausesComponentVM,
        },
    }
    
    useEffect(() => {
        if (!_.isUndefined(building)) {
            getCoverages();
        }
    }, [])

    // DE16198
    const getCoveragesToDisplay = useCallback(() => {
        const blanketCoverages = _.get(building, 'blanket_TWIA.coverages.value') !== undefined ?
            _.get(building, 'blanket_TWIA.coverages.value') : _.get(building, 'blanket_TWIA.coverages');
        const BUILDING_PROPERTY_COVS = ['CPBPPCov', 'CPBldgCov']

        if(!_.isUndefined(blanketCoverages)){
            // DE16212
            if (isPolicySummary) {
                return building?.coverages.concat(blanketCoverages)
                    .filter(blgcov => (blgcov.selected || blgcov.required) && 
                    !_.includes(BUILDING_PROPERTY_COVS, blgcov.publicID))
            }
            return building.coverages.concat(blanketCoverages) // DE17566
            .filter(blgcov => (blgcov.selected || blgcov.required) && 
            !_.includes(BUILDING_PROPERTY_COVS, blgcov.publicID))
        }
        
        if (isPolicySummary) {
            return building?.coverages?.filter(blgcov => blgcov.selected || blgcov.required)
        }

        return building?.coverages?.filter(blgcov => blgcov.selected || blgcov.required)
    }, [building, isPolicySummary]);
        
    const removePremiumProperties = (o) => {
        const removeAmountProps = (i) => {
            delete i.amount;
        };
    
        Object.keys(o).forEach(prop => {
            if (o[prop]) {
                removeAmountProps(o[prop]);
            }
        });
        
        return o;
    };
    
    const hideNonVisibleCoverageTerms = (cpData) => {
        const HIDE_COVTERM_NAMES = ['Valuation Method', 'Coinsurance'];
        const excludeCoverageTerms = (coverage) => {
            coverage.terms = coverage?.terms?.filter(t => !HIDE_COVTERM_NAMES.includes(t.name));
        };
        
        const excludedCoverages = cpData?.forEach(excludeCoverageTerms)
        return excludedCoverages;
    }
    
    const getCoverages = () => {
        const coverages = _.get(building, 'coverages');
        removePremiumProperties(coverages);
        hideNonVisibleCoverageTerms(coverages);
    }

    const overrideProps = {
        buildingCoverages: {
            value: getCoveragesToDisplay(),
            isEditable: false,
            path: `${buildingPath}.coverages`,
            splitByClauseCategory: true,
            isCommericalCoverageScreen: true,
            isCommercialSummary : true,
            showAmount:true,
            showCoverageNameAmount : false,
            isClaimSummary: true
        }
    }

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={building}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    )

}

export default CoverageSummaryAccordion